export default __webpack_public_path__ + "static/media/Earn-Points-img.74efcdca.jpg";